import { ProductPageSection } from "./ProductPageSection";
import { Box } from "@chakra-ui/layout";
import { IProduct } from "interfaces/product.interface";
import { Checkpoint } from "components";
import { Stack } from "@chakra-ui/react";
import { ProductMastheadCheckpoints } from "./ProductPageMastheadCheckpoints";
import { ICheckPoint } from "interfaces/product-cta-interface";
import { ProductCustomCheckpoints } from "./ProductCustomCheckpoints";

export const ProductPagePricing = ({ product }: { product: IProduct }) => {
  const { color, pricingCheckpoints } = product;

  return (
    <ProductPageSection id="pricing" title="Pricing">
      <Box
      // p={8}
      // rounded="md"
      // border="1px solid"
      // borderColor="gray.150"
      // bg="gray.100"
      >
        <Box display="flex" mb={2}>
          <Box fontSize="4xl" fontWeight={600} lineHeight="none">
            {/* £{product.price} */}
            {product.price === "Free" || "free"
              ? `${product.price}`
              : `${product.price}`}
          </Box>
        </Box>
        <Box color={`gray.600`} fontWeight={400} mb={4}>
          {product.additionalCharges}
        </Box>
        <Stack
          spacing={3}
          fontSize="md"
          display={{ base: "none", lg: "block" }}
        >
          {pricingCheckpoints && (
            <ProductCustomCheckpoints
              items={pricingCheckpoints}
              color={color}
            />
          )}
        </Stack>
      </Box>
    </ProductPageSection>
  );
};
